// src/utils/logger.ts

const isDevelopment =
  process.env.NODE_ENV !== 'production';

export const logger = {
  // Define emojis as Unicode characters
  icons: {
    request: '📤',
    response: '📥',
    init: '🔧',
    image: '🖼️',
    error: '❌',
    success: '✅',
    warning: '⚠️',
    arrow: '→',
    lock: '🔒',
    network: '🌐',
    database: '💾',
    auth: '🔐',
    cart: '🛒',
    order: '📦',
    payment: '💳',
    user: '👤',
    admin: '👑',
    chat: '💬',
    product: '📱',
    search: '🔍',
    filter: '⚙️',
    delete: '🗑️',
    edit: '✏️',
    add: '➕',
    save: '💾',
    loading: '⏳',
    time: '⏰',
    location: '📍',
    phone: '📞',
    email: '📧',
    calendar: '📅',
    star: '⭐'
  },

  request(method: string, url: string) {
    if (!isDevelopment) return;

    console.log(
      `${this.icons.request} ${method} ${url}`
    );
  },

  response(status: number, url: string) {
    if (!isDevelopment) return;

    console.log(
      `${this.icons.response}${status} ${url}`
    );
  },

  image(path: string, fullUrl?: string) {
    if (!isDevelopment) return;

    console.log(
      `${this.icons.image} Original: ${path}`
    );

    if (fullUrl) {
      console.log(
        `  ${this.icons.arrow} Full: ${fullUrl}`
      );
    }
  },

  error(message: string, details?: any) {
    if (!isDevelopment) return;

    console.error(
      `${this.icons.error} ${message}`,
      details || ''
    );
  },

  success(message: string) {
    if (!isDevelopment) return;

    console.log(
      `${this.icons.success} ${message}`
    );
  },

  init(message: string) {
    if (!isDevelopment) return;

    console.log(
      `${this.icons.init} ${message}`
    );
  }
};